module.exports = __webpack_public_path__ + "media/src/img/dzen-icon-5d9c30db4a5c87647df963e8810a778f.svg";